/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DocumentType } from './DocumentType';
import {
    DocumentTypeFromJSON,
    DocumentTypeFromJSONTyped,
    DocumentTypeToJSON,
    DocumentTypeToJSONTyped,
} from './DocumentType';

/**
 * 
 * @export
 * @interface Document
 */
export interface Document {
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    documentId: string;
    /**
     * 
     * @type {DocumentType}
     * @memberof Document
     */
    documentType: DocumentType;
    /**
     * 
     * @type {Date}
     * @memberof Document
     */
    createdAt: Date;
    /**
     * Whether the customer may remove this document from the shipment. True only for photos they or their shipper uploaded, while the booking is confirmed.
     * @type {boolean}
     * @memberof Document
     */
    customerCanRemove: boolean;
}



/**
 * Check if a given object implements the Document interface.
 */
export function instanceOfDocument(value: object): value is Document {
    if (!('documentId' in value) || value['documentId'] === undefined) return false;
    if (!('documentType' in value) || value['documentType'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('customerCanRemove' in value) || value['customerCanRemove'] === undefined) return false;
    return true;
}

export function DocumentFromJSON(json: any): Document {
    return DocumentFromJSONTyped(json, false);
}

export function DocumentFromJSONTyped(json: any, ignoreDiscriminator: boolean): Document {
    if (json == null) {
        return json;
    }
    return {
        
        'documentId': json['documentId'],
        'documentType': DocumentTypeFromJSON(json['documentType']),
        'createdAt': (new Date(json['createdAt'])),
        'customerCanRemove': json['customerCanRemove'],
    };
}

  export function DocumentToJSON(json: any): Document {
      return DocumentToJSONTyped(json, false);
  }

  export function DocumentToJSONTyped(value?: Document | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'documentId': value['documentId'],
        'documentType': DocumentTypeToJSON(value['documentType']),
        'createdAt': ((value['createdAt']).toISOString()),
        'customerCanRemove': value['customerCanRemove'],
    };
}

